var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "language-textarea" },
    [
      _c(_setup.LanguageRadioButtons, {
        staticClass: "language-textarea-lang",
        attrs: { value: _vm.lang },
        on: { input: _setup.handleLangChange },
      }),
      _c("el-input", {
        attrs: {
          value: _setup.currentText,
          type: _vm.type,
          rows: _vm.rows,
          placeholder: _vm.placeholder,
          maxlength: _vm.maxlength,
          "show-word-limit": _vm.showWordLimit,
        },
        on: { input: _setup.handleTextInput },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }